module.exports = __webpack_public_path__ + "img/vertical_1_1_3016.d97d09cf.png";